<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description:
 -->
<template>
    <el-container v-loading="homeLoading" element-loading-background="rgba(255, 255, 255, 0.3)" element-loading-text="加载中">
        <el-header height="65px" class="pro-header">
            <!-- <Header></Header> -->
        </el-header>

        <el-container class="pro-container">
            <el-main :class="wideContent.includes($route.name) ? 'wide-main' : 'narrow-main'">
                <router-view ref="dashboard" class="main-con"> </router-view>
            </el-main>
        </el-container>

        <!-- 右侧固定导航 -->
        <div class="elevator" v-if="$route.path != '/home/knowledge-center'">
            <ul @click="$router.push('/home/knowledge-center')">
                <li>
                    <span><img src="@/assets/images/img59.png" alt=""></span>
                    <p>知识中心</p>
                </li>
            </ul>
        </div>
    </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
// import Header from '../components/Header';
export default {
    name: 'home',
    components: {
        // Header
    },
    data () {
        return {
            show: true,
            wideContent: []
        };
    },
    created () {
    },
    mounted () {
    },
    watch: {},
    computed: {
        homeLoading () {
            return this.$store.state.homeLoading;
        }
    },
    methods: {
        handleclick: function () {
            this.show = (this.show !== true);/* 或者 this.show = !this.show */
        }
    }
};
</script>
<style lang="scss" scoped>
.pro-container {
    display: flex;
    background: #eaebf5;
    justify-content: center;
}
.el-header {
    padding: 0 !important;
    border-bottom: 5px solid #ec5855;
}

.el-main {
    flex: none;
    display: flex;
    margin: 0 20px;
    // max-width: 80%;
    // padding: 20px 20px 0 20px;
    padding: 0;
    padding-top: 20px;
    overflow: hidden;
    box-sizing: content-box;
}
    .elevator {
        position: fixed;
        bottom: 5%;
        right: 1%;
        z-index: 99;
        ul {
            background: #ffffff;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            border-radius: 8px 8px 8px 8px;
            overflow: hidden;
            opacity: 1;
            li {
                // width: 118px;
                // height: 128px;
                width: 6.2vw;
                height: 13.8vh;
                min-width: 90px;
                min-height: 100px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                border-bottom: 1px solid #e3e3e3;
                img {
                    width: 44px;
                }
                &:last-child {
                    border-bottom: none;
                }
                p {
                    color: #333;
                    line-height: 1;
                    font-size: 0.85vw;
                }
                &:hover {
                    background-color: #f9f9f9;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ./src/views/Home.vue